"use strict";

/**
 * Collection Data Model
 * @typedef {array<ArcModel>} ArcCollection
 */

exports.unused = {};